import type HighchartsESM from 'highcharts/es-modules/masters/highcharts.src';

let highcharts: typeof HighchartsESM | null = null;

export async function loadHighcharts(): Promise<typeof HighchartsESM> {
    if (!highcharts) {
        // First load core
        const core = await import('highcharts/es-modules/masters/highcharts.src').then(m => m.default);
        highcharts = core;

        // Then load all modules in parallel, and in an unspecified order
        await Promise.all([
            import('highcharts/es-modules/masters/highcharts-more.src'),
            import('highcharts/es-modules/masters/modules/exporting.src'),
            import('highcharts/es-modules/masters/modules/export-data.src'),
            import('highcharts/es-modules/masters/modules/accessibility.src'),
            import('highcharts/es-modules/masters/modules/annotations.src'),
            import('highcharts/es-modules/masters/modules/heatmap.src'),
            import('highcharts/es-modules/masters/modules/map.src')
        ]);
    }

    return highcharts;
}